import * as React from "react";
import { NavLink, Redirect } from "react-router-dom";
import { connect } from "react-redux";
import { logout } from "../actions/auth";
import { change } from "../actions/search";
import { changeCounts } from "../actions/counts";
import { toast } from "react-toastify";
import Axios, { AxiosResponse } from "axios";
import config from "../config";

import i18n from "../config/i18next";
import { withTranslation } from "react-i18next";
import ReportModal from "./ReportModal";
import { arrayToFormData } from "../utils/functions";

let searchPages = [
    '/admin/producers',
    '/admin/holders',
    '/admin/objects',
    '/admin/no-sorted',
    '/admin/holder/',
];

interface IState {
    query: string;
    searching: boolean;
    variants: string[];
    isOpen: boolean;
    fileInput: any;
    file: File;
}

const CancelToken = Axios.CancelToken;
let cancel: any;

class Navbar extends React.Component<any, IState> {
    public state: IState = {
        query: "",
        searching: false,
        isOpen: false,
        variants: [],
        fileInput: null,
        file: null,
    };

    constructor(props: any) {
        super(props);

        this.handleModal = this.handleModal.bind(this);
    }

    componentDidMount() {
        if (!this.props.counts.artists) {
            this.props.changeCounts();
        }
    }

    logoutHandler() {
        this.props.logout();
        this.props.history.push("/login");
    }

    changeLanguage(lang: string) {
        i18n.changeLanguage(lang);
        localStorage.setItem("language", lang);
    }

    handleModal() {
        this.setState({
            isOpen: !this.state.isOpen,
        });
    }

    async onChangeHandler(value: string) {
        cancel && cancel();

        this.setState(
            {
                query: value,
            },
            async () => {
                try {
                    let response: AxiosResponse = await Axios.get(
                        `${config.host}/stat/variants?query=${this.state.query}`,
                        {
                            cancelToken: new CancelToken(function executor(c) {
                                cancel = c;
                            }),
                        }
                    );

                    this.setState({
                        variants: response.data,
                    });
                } catch (err) { }
            }
        );
    }

    search() {
        if (this.state.searching && this.state.query.length > 1) {
            this.setState({
                searching: false,
            });

            return <Redirect to={"/search/" + this.state.query} />;
        }
    }

    uploadDefault(e: any) {
        if (confirm("Загрузить выбранный файл?") && e.target.files.length > 0) {
            this.setState(
                {
                    file: e.target.files[0],
                },
                async () => {
                    let url = `${config.api}/uploads/default`;

                    let response: AxiosResponse = await Axios.post(
                        url,
                        arrayToFormData({
                            file: this.state.file,
                        })
                    );

                    if (response.data.status == "success") {
                        toast(
                            "Отчёт успешно загружен. Количество сохранённых строк: " +
                            response.data.saved,
                            { type: "success" }
                        );
                    } else {
                        toast(response.data.message, { type: "error" });
                    }

                    this.setState({
                        file: null,
                    });
                }
            );
        } else {
            this.setState({
                file: null,
            });
            toast("Отменён.", { type: "info" });
        }

        this.state.fileInput.value = null;
    }

    render() {
        const { t, auth, search } = this.props;

        return (
            <div>
                <ReportModal
                    isOpen={this.state.isOpen}
                    handleModal={this.handleModal}
                />
                <input
                    type="file"
                    ref={(ref) => (this.state.fileInput = ref)}
                    className="d-none"
                    accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                    onClick={(e: any) => {
                        e.stopPropagation();
                    }}
                    onChange={(e: any) => {
                        this.uploadDefault(e);
                    }}
                />
                <div className="admin-header">
                    <NavLink to="/admin" className="admin-header__logo">
                        <img src="img/admin_logo.png" alt="" />
                    </NavLink>
                    <div className="hamburger">
                        <span></span>
                        <span></span>
                        <span></span>
                    </div>
                    <div className="admin-header__content">
                        <form className="admin-header__form" action="">
                            {(searchPages.includes(this.props.location.pathname) || this.props.location.pathname.startsWith("/admin/holder")) && <div>
                                <input
                                    type="text"
                                    placeholder="Поиск по сайту..."
                                    value={search}
                                    onChange={(e: any) => {
                                        this.props.change(e.target.value);
                                    }}
                                />
                                <img src="img/admin_search_icon.png" alt="" />
                            </div>}
                        </form>
                        <div className="admin-header__info">
                            <select className="admin-header__select" onChange={(e:any) => {
                                if (e.target.value === "uz_crm") {
                                    window.location.href = "https://uz.rizanova.site/";
                                }
                            }}>
                                <option value="crm">CRM</option>
                                <option value="uz_crm">UZ CRM</option>
                            </select>

                            <div className="admin-name">
                                <span>Привет, </span>
                                <span>{auth?.user?.full_name}</span>
                            </div>
                            {auth?.user?.image && (<a className="admin-avatar" role="button">
                                <img src={auth?.user?.image} />
                            </a>)}
                            {/* <div className="admin-header__bell">
                                <img src="img/bell.png" alt="" />
                                <div className="counter"></div>
                            </div> */}
                            <a
                                className="admin-header__log-out cursor-pointer"
                                role="button"
                                onClick={() => this.logoutHandler()}
                            >
                                <span>ВЫЙТИ</span>
                                <img src="img/log_out_icon.png" alt="" />
                            </a>
                        </div>
                    </div>
                </div>

                <div className="admin-hero">
                    <div className="admin-sidebar">
                        <NavLink
                            className="admin-sidebar__icon"
                            to="/admin/"
                            title="Главная"
                        >
                            <img src="img/homee.svg" alt="" />
                        </NavLink>
                        <NavLink
                            className="admin-sidebar__icon"
                            to="/admin/holders"
                            title="Партнеры"
                        >
                            <img src="img/2.svg" alt="" />
                            <span className="badge">{this.props.counts.artists}</span>
                        </NavLink>
                        {/* <NavLink
                            className="admin-sidebar__icon"
                            to="/admin/producers"
                            title="Продюсеры"
                        >
                            <img src="img/3.svg" alt="" />
                        </NavLink> */}
                        <NavLink
                            className="admin-sidebar__icon"
                            to="/admin/objects"
                            title="Объекты"
                        >
                            <img src="img/4.svg" alt="" />
                            <span className="badge">{this.props.counts.compositions}</span>
                        </NavLink>
                        <NavLink
                            className="admin-sidebar__icon"
                            to="/admin/groups"
                            title="Группы"
                        >
                            <img src="img/5.svg" alt="" />
                        </NavLink>
                        <NavLink
                            className="admin-sidebar__icon"
                            to="/admin/moderators"
                            title="Сотрудники"
                        >
                            <img src="img/6.svg" alt="" />
                        </NavLink>
                        <NavLink
                            className="admin-sidebar__icon"
                            to="/admin/requests"
                            title="Запросы"
                        >
                            <img src="img/7.svg" alt="" />
                            <span className="badge ">{this.props.counts.requests}</span>
                        </NavLink>
                        <NavLink
                            className="admin-sidebar__icon"
                            to="/admin/settings"
                            title="Настройки"
                        >
                            <img src="img/8.svg" alt="" />
                        </NavLink>
                        <NavLink
                            className="admin-sidebar__icon"
                            to="/admin/no-sorted"
                            title="Несортированные"
                        >
                            <img src="img/9.svg" alt="" />
                            <span className="badge ">{this.props.counts.nosorted}</span>

                        </NavLink>
                        <NavLink
                            className="admin-sidebar__icon"
                            to="/admin/black-list"
                            title="Чёрный список"
                        >
                            <img src="img/10.svg" alt="" />
                        </NavLink>
                        <NavLink
                            className="admin-sidebar__icon"
                            to="/admin/questions"
                            title="Вопросы"
                        >
                            <img src="img/11.svg" alt="" />
                            <span className="badge ">{this.props.counts.tickets}</span>

                        </NavLink>
                        <div className="btn-menu">
                            <a role="button" className="btn-main">
                                <img src="img/btn-plus.svg" alt="" />
                            </a>
                            <nav className="btn-menu__btns">
                                <a
                                    role="button"
                                    onClick={() => {
                                        this.handleModal();
                                    }}
                                >
                                    <img src="img/btn-file-upload.svg" alt="" />
                                </a>
                                <a
                                    role="button"
                                    onClick={() => {
                                        this.state.fileInput.click();
                                    }}
                                >
                                    <img src="img/btn-user.svg" alt="" />
                                </a>
                                <NavLink role="button" exact to="/admin/reports">
                                    <img
                                        src="img/btn-file-archive.svg"
                                        alt=""
                                    />
                                </NavLink>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state: any) {
    return {
        auth: state.auth,
        search: state.search,
        counts: state.counts,
    };
}

export default connect(mapStateToProps, { logout, change, changeCounts })(withTranslation()(Navbar));
